import * as React from 'react';

// Context
import { RouteLoadingContext } from '@shopee/route-loading-context';

// Hooks
import { useShouldHideBack } from '@shopee-user/with-web-view';
import { useTranslation } from '@shopee-user/platform';

// Components
import { AuthBackgroundContainer } from '@shopee-user/business-customization-ui';
import { Navbar, PageLoading } from '@shopee-user/business-customization-ui';
import { HelpSpan } from '@shopee-user/business-customization-ui';

// Utils
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';
import { isWebBridgeSupported } from '@shopee-user/platform';

// Enums
import { Feature } from '@shopee-user/feature-toggle';

// Styles
import styles from './style.scss';

export default function PageLogin() {
  const isShopeePayLegacyWeb =
    isFeatureEnabled(Feature.ShopeePayLoginByPassword) &&
    !isWebBridgeSupported();
  const shouldHideBack = useShouldHideBack() || isShopeePayLegacyWeb;
  const I18n = useTranslation();

  return (
    <AuthBackgroundContainer
      className={
        isFeatureEnabled(Feature.ShopeePayLoginByPassword)
          ? styles.shopeePayLegacyContainer
          : styles.container
      }
    >
      <Navbar
        title={I18n.t('label_login')}
        rightContent={<HelpSpan text={I18n.t('label_help')} />}
        onClickBack={() => undefined}
        shouldHideBack={shouldHideBack}
      />
      <RouteLoadingContext.Consumer>
        {({ showLoadingPlaceholder }) => {
          if (showLoadingPlaceholder) {
            return <PageLoading />;
          } else {
            return null;
          }
        }}
      </RouteLoadingContext.Consumer>
    </AuthBackgroundContainer>
  );
}
